(function() {
    'use strict';

    angular.module('ib-pmt-summary-seats-module',[])
})();